import React, { useState } from "react";
import "./MapInfoBox.css";
import { FaInfoCircle } from "react-icons/fa";

const MapInfoBox = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="map-info-container">
      {/* <button
        className="info-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Map Information"
      >
      </button> */}
    <button className="info-btn" onClick={() => setIsOpen(!isOpen)}>
    <FaInfoCircle style={{ color: "#333333", fontSize: "16px" }} />
    </button>
      <div className={`info-box ${isOpen ? "show" : ""}`}>
        <div className="info-header">
          <strong>Overview Information</strong>
          <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
        </div>
        <div className="info-body">
          <p>This map visualizes:</p>
          <ul>
            <li><b>Catchments</b> with interactive names</li>
            <li><b>Major rivers</b> as blue networks</li>
            <li><b>Discharge points</b> as black markers</li>
          </ul>
          <p>Hover over elements to explore data.</p>
        </div>
      </div>
    </div>
  );
};

export default MapInfoBox;
